import * as React from "react"
import { Media } from "reactstrap"
import { Paper, Typography } from "components"
import { Image } from "types/blog"
import { Link } from "react-router-dom"
import { useInView } from "react-intersection-observer"

import "./blogItem.scss"

interface BlogItem {
	page_title: string
	image: Image
	page_description: string
	updated_at: string
	released_at: string
	user_name: string
	className?: string
	page_url: string
}

const BlogItem: React.FC<BlogItem> = ({
	className,
	page_title,
	image,
	page_description,
	user_name,
	released_at,
	updated_at,
	page_url,
}) => {
	const [ref, inView] = useInView({ triggerOnce: true, rootMargin: "100px" })
	return (
		<Paper className={className || ""}>
			<Media className="m-3 blog-item__media">
				<Media right>
					<Link to={`/post/${page_url}`}>
						<div ref={ref}>
							<Media
								object
								className="blog-item__image ml-3 mr-2"
								src={inView ? image.med : ""}
								alt="Generic placeholder image"
							/>
						</div>
					</Link>
				</Media>
				<Media body>
					<Link to={`/post/${page_url}`}>
						<Typography
							variant="h6"
							component="h2"
							weight="bold"
							color="dark"
						>
							{page_title}
						</Typography>
					</Link>
					<Typography
						paragraph
						color="muted"
						variant="caption"
						className="my-2"
					>{`${user_name} | نوشته شده در: ${released_at} | بروزرسانی در: ${updated_at}`}</Typography>
					<Typography paragraph className="d-inline" variant="body2">
						{page_description}
						{"  "}
						<Link
							className="d-inline text-nowrap"
							to={`/post/${page_url}`}
						>
							ادامه مطلب
						</Link>
					</Typography>
				</Media>
			</Media>
		</Paper>
	)
}

export default BlogItem
